import React , {useState, useEffect} from 'react'
import { GetAllNotifications } from './API';
import NotificationItem from './NotificationItem';

export default function NotificationList(props) {
    
    const [data, setData] = useState([])
    useEffect(() => {
        GetAllNotifications(props.limit).then(data => {
            setData( data );
        });
    }, [])
    return (
        <React.Fragment>
            {data.map( item => <NotificationItem  {...item} /> )}
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/pages/Notifications/NotificationList.js